import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useMemo } from 'react';
import { useForm } from 'antd/lib/form/Form';
export var useSectionForm = function useSectionForm(_ref) {
  var section = _ref.section,
      localTitle = _ref.localTitle,
      localDescription = _ref.localDescription,
      sectionLabel = _ref.sectionLabel,
      onUpdateSection = _ref.onUpdateSection;

  var _useForm = useForm(),
      _useForm2 = _slicedToArray(_useForm, 1),
      form = _useForm2[0];

  var handleSectionTitleFocus = useCallback(function (inputValue) {
    var defaultTitleText = "".concat((sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.defaultSectionTitle) || '');
    var isDefaultTitleText = inputValue === defaultTitleText;

    if (isDefaultTitleText) {
      form.setFieldsValue({
        title: ''
      });
    }
  }, [sectionLabel, form]);
  var handleSectionTitleBlur = useCallback(function (inputValue) {
    var isEmptyInputValue = !inputValue.length;

    if (isEmptyInputValue) {
      var defaultTitleText = "".concat((sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.defaultSectionTitle) || '');
      form.setFieldsValue({
        title: defaultTitleText
      });
      onUpdateSection === null || onUpdateSection === void 0 ? void 0 : onUpdateSection('title', defaultTitleText);
    }
  }, [sectionLabel, form, onUpdateSection]);
  var onFieldsChange = useCallback(function (e) {
    var _e = _slicedToArray(e, 1),
        infoChange = _e[0];

    if (!infoChange) return;
    var name = infoChange.name,
        value = infoChange.value;

    var _name = _slicedToArray(name, 1),
        field = _name[0];

    onUpdateSection === null || onUpdateSection === void 0 ? void 0 : onUpdateSection(field, value);
  }, [onUpdateSection]);
  var initialValues = useMemo(function () {
    return _objectSpread(_objectSpread({}, section), {}, {
      title: localTitle,
      description: localDescription
    });
  }, [section, localTitle, localDescription]);
  return {
    form: form,
    initialValues: initialValues,
    handleSectionTitleFocus: handleSectionTitleFocus,
    handleSectionTitleBlur: handleSectionTitleBlur,
    onFieldsChange: onFieldsChange
  };
};